import {createSelector} from 'reselect';
import {getDuplicatePerson, getLoginForm, selectAllClubs, clubRegionExternalId} from '../../App/selectors';

const selectDuplicatePerson = createSelector([getDuplicatePerson], duplicate => duplicate.toJS());
const selectLoginForm = createSelector([getLoginForm], login => login);
export {selectAllClubs, selectDuplicatePerson, selectLoginForm, clubRegionExternalId};
